import React, { useState, useEffect, useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import axios from "../../../../axios/index"

// Context
import { UserContext } from '../../../Context/UserContextProvider';

// components
import ShowProfileModal from '../../DashboardFileManagement/CardDetail/ShowProfileModal';
import DashboardHeader from '../../DashboardReuseAbleComponents/DashboardHeader';
import DashboardSideMenu from '../../DashboardReuseAbleComponents/DashboardSideMenu';
import RequestResponseForm from './RequestResponseForm';
import { SelectedAreas } from '../../../UserDashboard/UserRequestFile/RequestDetail/RequestDetail';
import { InputData } from '../../../UserDashboard/UserRequestFile/RequestDetail/RequestDetail';
import { PricesData } from '../../../UserDashboard/UserRequestFile/RequestDetail/RequestDetail';

// Styles
import styles from "../../DashboardReuseAbleComponents/AddNewFile.module.css";
import Dstyles from "./../../DashboardFileManagement/DashboardFileManagement.module.css";

//images
import arrowIcon from "../../../../assets/img/DashboardICons/ArrowRounded.svg"
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

function RequestedFilesDetail() {
    const { userToken } = useContext(UserContext);
    const history = useHistory();
    const { state } = useLocation();
    const [modalShow, setModalShow] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    const [fileData, setFileData] = useState({
        title: "",
        category: "",
        meter: "",
        facilities: "",
        description: "",
        city: "",
        place: ["ولیعصر , رشدیه , باغمیشه"],
        year: "",
        room: "",
        floor: "",
        startPrice: "",
        endPrice: "",
        consultantSuggestions: ""
    })


    useEffect(() => {
        const dataHandler = async () => {
            // setIsLoading(true)

            const getRequestDetail = await axios.get(
                `RequestFile/${state.id}`,
                {
                    headers: { authorization: "Bearer " + userToken },
                }
            );

            const data = await getRequestDetail.data.data;
            const addedPlaces = data?.requestFileAreas.map(item => item.value)

            const allSuggestedFiles = data.consultantSuggestions.reduce((accumulator, currentValue) => {
                return accumulator.concat(currentValue.suggestedFiles);
            }, []);

            setFileData((prev) => {
                return { ...prev, meter: data.meterage, startPrice: data.startPrice, endPrice: data.entPrice, description: data.description, city: data.city, year: data.constructionYear, room: data.roomCount, floor: data.floor, facilities: data.specifications, consultantSuggestions: allSuggestedFiles, place: addedPlaces };
            });

            setIsLoading(false)
        }

        dataHandler()
    }, [userToken, state.id])

    return (
        <>
            <ShowProfileModal
                show={modalShow}
                onHide={() => setModalShow(false)}
            />
            {isLoading ? (
                <div className={Dstyles.loader_container}>
                    <div className={Dstyles.spinner}></div>
                </div>
            )
                : (
                    <div className='container-fluid'>
                        <div className='row'>
                            <div className="col-md-9" >
                                <div className={`my-3 px-4 ${Dstyles.container}`} dir='rtl'>
                                    <DashboardHeader onClick={() => setModalShow(true)} />

                                    {/* Type Header start */}
                                    <div className="py-2 mb-3">
                                        <div className="container-fluid">
                                            <div
                                                className="d-flex flex-column justify-content-center flex-wrap align-items-start ms-md-5 ms-0 mt-3"
                                                dir="rtl"
                                            >
                                                <div className='w-100 d-flex align-items-center justify-content-start flex-wrap mt-2 mb-2 '>
                                                    <a href='#' onClick={history.goBack}><img className='ms-2 pointer' src={arrowIcon} alt="icon" /></a>
                                                    <div className={Dstyles.text1}>
                                                        {state.title ? state.title : ""}
                                                    </div>
                                                </div>

                                                <div className='w-100 d-flex align-items-center justify-content-start flex-wrap mt-2 mb-2'>
                                                    <div className={styles.card_text2}>
                                                        نوع ملک درخواست شده:
                                                    </div>
                                                    <div className={Dstyles.text1}>
                                                        {state.categoryTitle}
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                    {/* Type Header end */}

                                    {/* details row 1 */}
                                    <div className="w-100 d-flex align-items-center justify-content-between flex-wrap my-2">
                                        <InputData value={fileData?.city} name="city" headerText="شهر" managment />
                                        <InputData value={fileData?.meter} name="meter" headerText="متراژ حداقل" managment />
                                        <InputData value={fileData?.year} name="year" headerText="عمر ساخت" managment />
                                    </div>
                                    {/* details row 1 */}

                                    {/* details row 2 */}
                                    <div className="w-100 d-flex align-items-center justify-content-md-start justify-content-center flex-wrap mt-2 mb-3">
                                        <InputData className="ms-md-5 ms-0" value={fileData?.room} name="room" headerText="تعداد اتاق خواب" managment />
                                        <InputData className="me-md-5 me-0" value={fileData?.floor} name="floor" headerText="طبقه" managment />
                                    </div>
                                    {/* details row 2 */}

                                    <SelectedAreas names={fileData?.place} />

                                    <PricesData startPrice={fileData?.startPrice} endPrice={fileData?.endPrice} />

                                    {/* facilities */}
                                    <div className='w-100 d-flex align-items-center justify-content-center flex-column flex-wrap my-3 px-3'>
                                        <div className='w-100 d-flex align-items-center justify-content-md-start justify-content-center'>
                                            <div className={Dstyles.card_title}>
                                                سایر امکانات
                                            </div>
                                        </div>
                                        <div className='w-100 d-flex align-items-center justify-content-between flex-wrap mt-3 mb-2 px-5'>
                                            {fileData.facilities?.map((item) => (
                                                <div key={item.id} className='d-flex align-items-center justify-content-center mt-3 mx-4'>
                                                    <div className={`ms-2 ${Dstyles.rounded_greeen}`}></div>
                                                    <div className={Dstyles.card_view_number}>
                                                        {item.value}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                    {/* facilities */}

                                    {/* Description */}
                                    <div className="py-2">
                                        <div className="container-fluid">
                                            <div
                                                className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-3"
                                                dir="rtl"
                                            >
                                                <div className='w-100 d-flex flex-column justify-content-center align-items-start mb-4'>
                                                    <div className={`mb-3 ${styles.text1}`}>
                                                        توضیحات
                                                    </div>
                                                    <textarea
                                                        id='menuone'
                                                        type="text"
                                                        name="description"
                                                        className={`w-100 px-3 pt-3 ${styles.textarea}`}
                                                        placeholder="توضیحات خود را وارد کنید"
                                                        value={fileData?.description}
                                                    ></textarea>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* Description */}

                                </div>

                                {fileData?.consultantSuggestions == "" ?
                                    <></>
                                    :
                                    <div className={`mt-3 mb-5 px-4 ${Dstyles.container}`} dir='rtl' style={{ minHeight: "390px" }}>
                                        <div className="container-fluid py-2 mb-3">
                                            {/* Type Header start */}
                                            <div className="text-end mt-3 mb-5" dir="rtl" >
                                                <div className={`mt-2 ${Dstyles.text1}`}>
                                                    فایل های ارسال شده
                                                </div>
                                            </div>
                                            {/* Type Header end */}

                                            <div className='w-100 d-flex flex-wrap justify-content-between align-items-center my-2'>
                                                {fileData?.consultantSuggestions.map((item) => (
                                                    <input
                                                        key={item.id}
                                                        type="text"
                                                        name={item.estateDto.fileCode}
                                                        value={item.estateDto.fileCode}
                                                        className={`bg-light py-2 ps-5 pe-2 my-3 ${styles.input_meter}`}
                                                        style={{ textAlign: "right" }}
                                                    />
                                                ))}
                                            </div>
                                        </div>

                                    </div>
                                }

                                <RequestResponseForm id={state.id} consultantSuggestions={fileData?.consultantSuggestions} />
                            </div>
                            <div className='col-md-3'>
                                {/* sideMenu starts */}
                                <DashboardSideMenu manageUsers manageRequestedFiles />
                                {/* sideMenu ends */}
                            </div>
                        </div>
                    </div>
                )}

        </>
    )
}

export default RequestedFilesDetail
